export default "__VITE_ASSET__kE05R8ss__"